import { DirectiveType } from '../../types';
import { AbstractSingleValueDirective } from '../abstract-single-value-directive';
export class RequireSriFor extends AbstractSingleValueDirective {
    getDirectiveName() {
        return 'require-sri-for';
    }
    getDirectiveType() {
        return DirectiveType.Other;
    }
}
